import React, { useState } from "react";
import "../CSS/styles.css";
import f1 from '../../assets/f1.png';
import f2 from '../../assets/f2.png';
import f3 from '../../assets/f3.png';
import f4 from '../../assets/f4.png';
import f5 from '../../assets/f5.png';
import f6 from '../../assets/f6.png';
import f7 from '../../assets/f7.png';
import f8 from '../../assets/f8.png';
import { Link } from "react-router-dom";

const All = () => {
  const [selectedOption, setSelectedOption] = useState("option1");

  const images = [
    {
      src: f1, alt: "Risk Management", showOn: ["option1", "option2"],
      title: "National Security Infrastructure Assessment",
      desc: "Comprehensive assessment and enhancement of security infrastructure for a national institution.",
    },
    {
      src: f2, alt: "Crisis Management", showOn: ["option1", "option3"],
      title: "Corporate Crisis Response System",
      desc: "Development of an integrated crisis response system for a multinational corporation.",
      descMarginBottom: "70px"
    },
    {
      src: f3, alt: "GIS", showOn: ["option1", "option6"],
      title: "Smart City GIS Implementation",
      desc: "GIS-based solution for urban planning and management in a major metropolitan area.",
      descMarginBottom: "70px"
    },
    {
      src: f4, alt: "Cyber Security", showOn: ["option1", "option7"],
      title: "Enterprise Cyber Security Program",
      desc: "Comprehensive cyber security program development for a financial services organization."
    },
    {
      src: f5, alt: "Training", showOn: ["option1", "option8"],
      title: "Security Training Program",
      desc: "Custom security training program for an international humanitarian organization.",
      descMarginBottom: "50px"
    },
    {
      src: f6, alt: "Digital Solutions", showOn: ["option1", "option9"],
      title: "Field Operations Mobile App",
      desc: "Secure mobile application for field operations and data collection.",
      descMarginBottom: "50px"
    },
    {
      src: f7, alt: "Research & Analysis", showOn: ["option1", "option5"],
      title: "Market Entry Research Study",
      desc: "Comprehensive research and analysis for market entry strategy in emerging markets."
    },
    {
      src: f8, alt: "Project Support", showOn: ["option1", "option4"],
      title: "Critical Infrastructure Project",
      desc: "End-to-end project management for critical infrastructure development."
    },
  ];

  const radioOptions = [
    { id: "option1", label: "All Projects" },
    { id: "option2", label: "Risk Management" },
    { id: "option3", label: "Crisis Management" },
    { id: "option4", label: "Project Support" },
    { id: "option5", label: "Research & Analysis" },
    { id: "option6", label: "GIS" },
    { id: "option7", label: "Cyber Security" },
    { id: "option8", label: "Training" },
    { id: "option9", label: "Digital Solutions" },
  ];

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.id);
  };

  return (
    <div className="container inter">
      <div className="row py-5 align-items-center justify-content-center">
        <div className="d-flex flex-wrap radio-container mt-4 justify-content-center gap-2">
          {radioOptions.map(({ id, label }) => (
            <div key={id} className="d-flex align-items-center">
              <input
                type="radio"
                className="btn-check"
                name="options"
                id={id}
                autoComplete="off"
                checked={selectedOption === id}
                onChange={handleOptionChange}
              />
              <label className="btn p-2 px-3 fs-6-5 fw-medium" htmlFor={id}>
                {label}
              </label>
            </div>
          ))}
        </div>

        <div className="row mt-5">
          {images.map(({ src, alt, showOn, title, desc, descMarginBottom }, index) =>
            showOn.includes(selectedOption) ? (
              <div key={index} className="col-lg-4 col-12 mt-4 int2">
                <div>
                  <img src={src} alt={alt} className="img-fluid w-100" />
                </div>
                <div className="wcc p-4 container-or-table3">
                  <div>
                    <p className="mb-0 bc fs-7 b5 ps-3 lgb p-2 w-50 fw-medium">{alt}</p>
                    <h5 className="mb-0 fw-semibold bc mt-3">{title}</h5>
                    <p className="mt-3 gc2" style={{ marginBottom: descMarginBottom || '0px' }}>{desc}</p>
                    <p className="mb-0 mt-4 bc fw-medium">
                      {index === 0 ? (
                        <Link to="/National" className="text-decoration-none bc">
                          View Project Details
                        </Link>
                      ) : index === 1 ? (
                        <Link to="/Corporate" className="text-decoration-none bc">
                          View Project Details
                        </Link>
                      ) : (
                        "View Project Details"
                      )}
                    </p>

                  </div>
                </div>
              </div>
            ) : null
          )}

        </div>
      </div>
    </div>
  );
};

export default All;
